<template>
  <div>
 
 <div v-if='!actloaded ' style="height:100vh;" class="d-flex align-items-center justify-content-center">
    <p>Loading...</p>
    
  </div>
  <div v-else >

 
<div style="height: 100vh;overflow: scroll;padding: 15px 0px;background:#fff;position:relative;z-index:10000000">

 <div class="bghead" style="height:70px"></div>

 
 <div  class="bghead  " style="position:fixed;top:0;left:0;right:0;background:#fff;z-index:1000000000">
  <div class="container" style="padding: 0 7px!important">
 
<div class="p-md-0 py-md-0    p-2 py-3">
  <div class=" acthead d-flex align-items-center  py-md-3 px-3 py-2 pl-4"  >
<div style="color: #313131" class="order-md-2 headtitle">{{ info.name}}</div>
<div style="width: 35px;height: 35px;overflow: hidden;border-radius: 50%" class="order-md-1">
  <img :src=" info.logo" class="img-fluid" style="width: 100%;height: 100%;object-fit: cover;">
</div>

<div style="flex: 1;overflow: hidden; padding-left:100px;padding-right: 30px " class="order-3 botlayerinv">
  <div style="background: #f5f7fa; border-radius: 10px;border:1px solid #bfcfdc" class="d-flex align-items-center ">
  <input type="text" style="    color: #333;
    box-shadow: 0 0 0;
    border: 0;
    background: 0 0;
    outline: none;
 
    height: 40px;
    padding: 0 18px;
    padding-right: 50px;width: 100%" placeholder="Search for products"  name="">
    <i class='bx bx-search' style="margin-right: 20px;font-size: 18px;color: #808080"></i>
  </div>
</div>
<div class="d-flex align-items-center order-4 ml-auto extrahead">
   
   
  <div>
        <router-link :to="'/'+$route.params.shopname+'/cart'" style='text-decoration:none'>

    <p style="margin-bottom: 0;margin: 0 15px;color: #313131;font-size: 15px">Cart</p>
  </router-link>

  </div>



<div class="dropdown">
  
      <p   class="  dropdown-toggle" data-toggle="dropdown"style="margin-bottom: 0;margin: 0 15px;color: #313131;font-size: 15px">My Account</p>





  <div class="dropdown-menu ">
 
<div style= " " >
  <div class=" p-2  my-1  shadbox1">

        <router-link :to="'/'+$route.params.shopname+'/order'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">playlist_add_check</i>
    <p style="margin-bottom: 0;font-family: 'Poppins', sans-serif;font-weight: 400;font-size: 13px;color:#111">Orders</p>
       </router-link>

  
  </div>
  
  <div class=" p-2  my-1  shadbox1">
                <router-link  :to="'/'+$route.params.shopname+'/login'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">directions_run</i>
    <p style="margin-bottom: 0;font-family: 'Poppins', sans-serif;font-weight: 400;font-size: 13px;color:#111">Visited store</p>
 </router-link>
  
  </div>
  
    <div class="  p-2  my-1  shadbox1">
                  <router-link  :to="'/'+$route.params.shopname+'/support'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">headset_mic</i>
    <p style="margin-bottom: 0;font-family: 'Poppins', sans-serif;font-weight: 400;font-size: 13px;color:#111"> support</p>
 
  </router-link>
  </div>


   <div class=" p-2  my-1  shadbox1"  v-if='!user'>
            <router-link :to="'/'+$route.params.shopname+'/login'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px ">exit_to_app</i>
    <p style="margin-bottom: 0;font-family: 'Poppins', sans-serif;font-weight: 400;font-size: 13px;color:#111">Log in</p>
 </router-link>
  
  </div>
    <div class="  p-2  my-1  shadbox1 d-flex align-items-center" style=""  v-if='user' v-on:click='logout'>
               
    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">exit_to_app</i>
    <p style="margin-bottom: 0;font-family: 'Poppins', sans-serif;font-weight: 400;font-size: 13px;color:#111">Sign out</p>
 
 
  </div>

</div>

 

  </div>
</div>



 

</div>
</div>

</div>
</div>
 </div>

 <div class="px-5   align-items-center justify-content-end cathead" style="background: #fcfcfc;border-bottom: 1px solid #e5e5e5">
       <span class="cattop">Packages</span>

       <span class="cattop">Furniture</span>

       <span class="cattop">Appliances</span>

     <span class="cattop">Electronics</span>

   <span class="cattop">Fitness</span>
 </div>


  <div style="padding: 8px" v-if=' actualorders!=null' >
    <div class="container py-md-3 py-0" >
      <div class="row justify-content-center">
        <div class="col-md-8">
       
   <i class="material-icons aricon" style="margin-left: -5px;position: relative;margin-top:5px;margin-bottom:5px" >arrow_back</i> 

    <div class="d-flex align-items-center justify-content-between">
      <p style="margin: 0!important;font-weight: 700" class="textsiz">Order #{{actualorders[0].orderid}}</p>
      <div class="d-flex align-items-center">
        <div style="width: 9px;height: 9px;border-radius: 50%;background: #fab73b;margin-right: 5px"></div>
         <p style="margin: 0!important;color: #808080;margin-left: 10px" class="textsiz">{{actualorders[0].status}}</p>
      </div>
    </div>
    <p style="margin: 0;color: #808080;font-weight: 300;" class="mt-2 textsiz">Today, 11:52 AM</p>
    <div style="height: 1px;background: #f5f7fa;margin-top: 16px;"></div>
    <p style="color: #808080;text-transform: uppercase;margin-top: 14px;font-size: 13px;letter-spacing: 0.3px" class="textsiz">{{actualorders[0].items.length}} Item</p>
    <div>

      <template v-for='a in actualorders[0].items '>
        

      <div class="d-flex align-items-start  mb-3">
        <div style="border-radius: 5px;overflow: hidden;" class="imgsiz">
          <img :src="a.imageurl" class="img-fluid ">
        </div>
        <div style="flex: 1;padding: 5px 13px">
          <p  style="margin-bottom: 10px;font-size: 16px" class="textsiz">{{a.name}}</p>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center ">
              <div style="width: 21px;height: 21px;border-radius: 3px;border:1px solid #7e9c9a" class="d-flex align-items-center justify-content-center">
                <span class="textsiz">{{a.quantity}}</span>
              </div>
              <span style="margin: 0 9px">x</span>
              <span class="textsiz">₹{{a.actprice}}.0</span>
            </div>
            <span class="textsiz">₹{{a.price}}.0</span>
          </div>
        </div>
        
      </div>      
    </template>
      



    </div>
        <div style="height: 1px;background: #f5f7fa;margin-top: 20px;"></div>
         <div style="padding: 0 0px">

          <div style="font-weight: 500;
    font-size: 13px;
    margin-bottom: 10px;
    color: #5d5b5b;letter-spacing: 0;margin-top: 16px" id="billdetails" class="textsiz">Bill Details</div>
    <div class="d-flex justify-content-between">
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;" class="textsiz">Item Total</span>
      <span style="font-size: 13px;  
    color: #313131;font-weight: 300;" id="itmtot" class="textsiz">₹{{actualorders[0].total}}</span>
    </div>

 <div class="d-flex justify-content-between mt-2 ">
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;" class="textsiz">Delivery Fee</span>
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;" id="delcharge" data-delcharge=39 class="textsiz">₹39</span>
    </div>

 
     <div class="d-flex justify-content-between    " style=" padding-top: 15px; padding-bottom: 10px ">
      <span style="font-size: 13.5px;
    color: #000;  font-weight: 700;
text-transform: uppercase;" class="textsiz">Grand total</span>
      <span style="font-size: 13.5px;
    color: #686b78;    font-weight: 700;
    color: #000;" id="totalpay" class="textsiz">₹{{actualorders[0].total + 39}}</span>
    </div>

</div>

        <div style="height: 1px;background: #f5f7fa;margin-top: 15px;"></div>
        <div>
          
          <div style="font-weight: 500;
    font-size: 13px;
    margin-bottom: 10px;
    color: #5d5b5b;letter-spacing: 0;margin-top: 16px" id="billdetails" class="textsiz">Contact Details</div>
    <div class="d-flex align-items-center mb-2">
      <div style="min-width: 120px;">
        <p style="color: #000;margin:0" class="textsiz">Name:</p>
      </div>
      <p style="color: #808080;margin: 0" class="textsiz">{{actualorders[0].name}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="min-width: 120px;">
        <p style="color: #000;margin:0" class="textsiz">Mobile:</p>
      </div>
      <p style="color: #808080;margin: 0" class="textsiz">{{actualorders[0].mobile}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="min-width: 120px;">
        <p style="color: #000;margin:0" class="textsiz">Address:</p>
      </div>
      <p style="color: #808080;margin: 0" class="textsiz">{{actualorders[0].address}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="min-width: 120px;">
        <p style="color: #000;margin:0" class="textsiz">City:</p>
      </div>
      <p style="color: #808080;margin: 0" class="textsiz">{{actualorders[0].city}}</p>
      
    </div>
        </div>

    <div style="height: 60px"></div>
  </div>
    
        </div>
        </div>
      </div>
</div>
 
 </div>

  
  </div>
</template>

<script>
 import firebase from 'firebase'

 
const fb = require('./firebaseconfig.js')
 
export default {
        props: ['loadstatus','info','products','category','deals','addcart','test','cart','orders'],

  
  data () {

        return{

            loaded:false,
            actualorder:null,
            user:false,
            singleorder:[],
            singdes:false,
            auth:false,
            actloaded:false,

        }
     
    
  },
  created(){
 

 console.log('this.$route.params.orderid')
 console.log(this.$route.params.orderid)
 if(firebase.auth().currentUser){

  this.auth=true
 }else{
  this.auth=false
 }

 var vm=this;
 
     if(this.auth){

console.log('testtttt')

console.log(this.$route.params.orderid)


     fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('orders').where("orderid", "==", Number(vm.$route.params.orderid)).onSnapshot(querySnapshot=>{
 
    querySnapshot.forEach((doc)=> {
      
 
  console.log(doc.data())
  vm.singdes=true
  vm.actloaded=true
 vm.singleorder.push(doc.data())

        
    })

  })


     this.user=true

  }else{
  if(this.auth){

  }else{

this.$router.push({ path: '/'+this.$route.params.shopname+'/login' })

  }
  console.log('222222')
    this.user=false
    this.singdes=false
 }
   console.log(this.$route.params.orderid)





        console.log(this.actualorder)

   },

   methods:{

         logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 alert('signed out successfully')
vm.user=false
}).catch(function(error) {
 
});
      },

    },
   computed:{

    actualorders(){

if(this.singdes){

 return this.actualorder=this.singleorder.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })

}else{

    return this.actualorder=this.orders.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })
    }
  }
   }

    
 
  
}
</script>
<style scoped>
 .imgsiz{

  width: 155px;
 }
 .textsiz{
  font-size:16px
 }
 .maincon{
  box-shadow: 0 1px 2px 0 #bfcfdc;
    background: #fff;
    border-radius: 5px;
  
 }
 .image{
  border-bottom-left-radius: 19px;
  border-bottom-right-radius: 19px;overflow: hidden;
  }

  .image img{
    width: 55px;height: 55px;border-radius: 50%;
    margin : 15px 0;
    margin-bottom: 7px;
     box-shadow: 0 4px 10px 0 rgba(191,207,220,.4);
  }
 .content{
  font-size: 12px;
    color: #313131;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    padding: 4px 3px
 }
 .padle{
  padding: 0 9px!important;text-align: center;
 }
 .cattitle{
  color: #313131;
  font-size: 14px;
      font-weight: 400;
 }



 /*
for deals of the day
 */

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}

 .err{
  color:rgb(250, 74, 91)!important; 
}
 .perr{
  color:rgb(250, 74, 91)!important; animation:blink 0.3s linear  
}

 .loglabels{

  font-size: 12px;
 
 
   transform: translateY(-70%);

 
}

 .maincon{
  box-shadow: 0 1px 2px 0 #bfcfdc;
    background: #fff;
    border-radius: 5px;
  
 }
 .image{
  border-bottom-left-radius: 19px;
  border-bottom-right-radius: 19px;overflow: hidden;
  }

  .image img{
    width: 55px;height: 55px;border-radius: 50%;
    margin : 15px 0;
    margin-bottom: 7px;
     box-shadow: 0 4px 10px 0 rgba(191,207,220,.4);
  }
 .content{
  font-size: 12px;
    color: #313131;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    padding: 4px 3px
 }
 .padle{
  padding: 0 9px!important;text-align: center;
 }
 .cattitle{
  color: #313131;
  font-size: 14px;
      font-weight: 400;
 }



 /*
for deals of the day
 */
.testanim{
  animation: show 1.5s forwards;animation-delay: 0s;
}

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}

.logininput{
    background-color: transparent;
    line-height: normal;
    border: none;
    outline: none;
    height: 50px;
    width: 100%;
    font-size: 16px;
    margin: 0;
    padding: 0 6px;

    padding-top: 22px;
    box-shadow: none;
    box-sizing: border-box;
    border-radius: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;color: #282c3f;
    border-bottom: 
}
.loglabel{

 
     position: absolute;
    left: 0;
    bottom: 7px;
    padding-left: 4px;
    line-height: 20px;
    font-size: 15px;
    cursor: text;
    transition: .2s ease;
    width: 100%;
    color: #93959f;
    will-change: transform,color,font-size;
    pointer-events: none;
    font-weight: 300;
    transition: all 0.3s;


 
}
.loglab{
  font-size: 12px;
    font-weight: 500;
    color: #7e808c;
 }


.logininput:focus + .loglabel{
  font-size: 12px;
    font-weight: 500;
    color: #7e808c;
   transform: translateY(-70%);

}
.loggrn{
      background-color: #7e9c9a;color: #fff;
      text-align: center;    font-size: 15px;
    font-weight: 700;padding: 9px;margin-top: 15px;
    border-radius: 4px;overflow: hidden;letter-spacing: 0.3px
  }

.labhead{
  position:relative;
  border-bottom: 1px solid #d4d5d9;
}
.deltitle{
  font-size: 30px;
    font-weight: 500;
    color: #282c3f;
 
 
    letter-spacing: -.3px;     
}
.addrdesc{
  color: #93959f;
 font-weight: 100;font-size: 14px;
    line-height: 18px; 
}
 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
     box-shadow: 0 1px 5px  rgba(0,0,0,.1);
        border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 14px;
   margin-bottom: 0!important;
   margin: 9px 0;
       padding-left: 5px;
 }
  .content2 h3{
    font-size: 15px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    margin: 8px 0;
    padding-left: 5px;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0;
    margin: 0 7px
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}
.bghead{
  background: #fff;
}
.acthead{
  background: #fff;
    padding: 15px;
    
    border-radius: 4px;
    margin: 0 -10px;
    justify-content: flex-start;
}
.headtitle{
  font-size: 25px;margin-left: 15px
}
.categoryhead{

  background: #f5f7fa
}

.categoryhead .container{

padding:  0 16px
}
.dealcon{
  background: #fff
}
 .botcon .container .con{
  background: #f5f7fa
}
.social{

  width: 30px;height: 30px;border-radius: 50%;box-shadow: 0 0 4px rgba(0,0,0,0.3);display: flex;
  align-items: center;justify-content: center;margin: 0 5px;background: #fff
}
.social i{
  font-size: 20px
}
.forbotmob{
  display: none;
}
.botlayer{
  display: none;
}
.botlayerinv{
 display: block;
}
.shad{
  background: #fff;padding: 30px;
  box-shadow:0 8px 14px 0 #bfcfdc;
  border-radius: 8px
}
.aricon{
  display: none;
}

.cathead{
  display: flex;
}

.cattop{
      color: #717171;
    font-size: 13px;
    font-weight: 300;padding: 15px 20px
}
@media (max-width: 992px) {
   


}
@media (max-width: 760px) {
  .imgsiz{

  width: 75px;
 }
 .textsiz{
  font-size:14.5px
 }
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin : 0
}

.cathead{
  display: none;
}

.cattop{
      color: #717171;
    font-size: 13px;
    font-weight: 300;padding: 15px 20px
}
   
.botlayer{
  display:block;
}
.botlayerinv{
  display: none!important;
}
.forbotpc{
  display: none;
}
.forbotmob{
  display: block;
}
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }
  .shad{
  background: transparent;padding: 0px;
  box-shadow:none;
}
.aricon{
  display: inline-block;
}

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
    box-shadow: none
  
 }

.dealcon{
  background: #f5f7fa
}
.acthead{
  background: #fff;
    padding: 15px;
    box-shadow: 0 2px 6px 0 rgba(191,207,220,.4);
    border-radius: 4px;
    justify-content: space-between;
     margin: 0!important
}
.bghead{
    display: none;
  background: transparent;
}

 .maincon{
  box-shadow: 0 1px 2px 0 #bfcfdc;
    background: #fff;
    border-radius: 5px;
    border:0
  
 }
 .categoryhead .container{

padding:  auto;
}
.headtitle{
  font-size: 15px;margin-left: 0px
}
.extrahead{
  display: none!important;
}
  .image img{
    width: 55px;height: 55px;border-radius: 50%;
    margin : 15px 0;
    margin-bottom: 7px;
     box-shadow: 0 4px 10px 0 rgba(191,207,220,.4);
  }
  .categoryhead{

  background: transparent;
}
 .cattitle{
  color: #313131;
  font-size: 14px;
  
      font-weight: 400;
 }
  .content{
    font-size: 14px;
  font-size: 12px;
    color: #313131;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    padding: 4px 3px!important
 }

}
 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}
@keyframes show{

  0%{

    opacity: 0
  }
  100%{
    opacity: 1
  }
}
</style>
 



// WEBPACK FOOTER //
// src/ordertest.vue